import { DiffViewer } from './DiffViewer';
import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

interface VersionComparisonDialogProps {
  isOpen: boolean;
  onClose: () => void;
  reconstructedVersionText: string;
  currentContent: string;
}

export function VersionComparisonDialog({
  isOpen,
  onClose,
  reconstructedVersionText,
  currentContent,
}: VersionComparisonDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6">{t('editor.comparing_versions')}</Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <Close sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {isOpen && (
          <DiffViewer previous={reconstructedVersionText} current={currentContent} />
        )}
      </DialogContent>
    </Dialog>
  );
}
